import { isElectron } from '~/utils/common'

const contraLogoStyle =
  'color: #D84040; font-weight: bold; font-family: monospace;'
const contraLogoArt = `%c
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░▒▓▓▓▓▓▓▓▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░▒▓███████████████▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░▓█████▒▒▒░░░▒▒▒▓██████░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░▒████▒░░░░░░░░░░░░░░▒▓██░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░▒████▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░████▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░▓███▓░░░░░░▒█████████████░░▒██████▓░░░█████████████████░███████████▓░▒███▓████░░░▒▒▒▓▓░░░░░░░
░░░░░░░████▓░░░░░░▒███▓▓▓▓▓▓▓███▓░▓███▒███▒░░████▓▓▓▓▓████▓▓▓▒░███▓▓▓▓▓▓███▒▒███▒▒████▒░░░░░░░░░░░░░
░░░░░░░████▓░░░░░░▒███░░░░░░░███▓░▓███░▒███▒░████░░░░░███▓░░░░░███▒░░░░▒███▒▒███▒░░████▓░░░░░░░░░░░░
░░░░░░░████▓░░░░░░▒███░░░░░░▒███▓░▓███░░▓██▓░███▓░░░░░███▓░░░░░███▒▓████▒░░░▒███▒░░░▓███▓░░░░░░░░░░░
░░░░░░░▒████▒░░░░░▓█████████████▓░▓███░░░▓██▓███▓░░░░░███▓░░░░░███▒░░▓████▒░▒███████▒▓███▓░░░░░░░░░░
░░░░░░░░█████▒░░░░░▓███████████▓░░▓███░░░░▓█████▒░░░░░███▓░░░░░███▒░░░░▓███▓░▓███▓░░░░▒████░░░░░░░░░
░░░░░░░░░█████▓░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▓███▓░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░██████▓▒░░░░░░░░░░░░░░▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░▒▓▓▓▓░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░▒████████▓▒▒▒▒▒▒▒▓██▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░▒▓█████████████▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░▒▓▓▓▓▓▒░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░
                                                                                                    `

const mangoLogoStyle =
  'color: #ff8a00; font-weight: bold; font-family: monospace;'
const mangoLogoArt = `%c
█████ ██████  ███████         ███████ █████  ██████████▓▓▓         ▓▓▓▓▓▓▓ ▓▓▓▓▓      ▓▓▒▒▒▒▒▒ ▒▒▒▒▒
███████████████████████    ████████████████  █████████▓▓▓▓▓▓    ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓   ▓▓▓▓▒▒▒▒▒▒▒▒▒▒▒▒▒
████████████████████████  █████████████████  ████████▓▓▓▓▓▓▓▓  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓  ▓▓▓▓▒▒▒▒▒▒▒▒▒▒▒▒
██████   ██████    █████  ██████     ██████  ██████     ▓▓▓▓▓ ▓▓▓▓▓▓      ▓▓▓▓▓▓ ▓▓▓▓▒▒▓    ▒▒▒▒▒▒▒
█████    ██████    █████ ██████      ██████  ██████     ▓▓▓▓▓ ▓▓▓▓▓▓       ▓▓▓▓▓ ▓▓▓▒▒▒      ▒▒▒▒▒▒
█████    ██████    █████  ██████     ██████  ████▓▓     ▓▓▓▓▓ ▓▓▓▓▓▓▓     ▓▓▓▓▓▓ ▓▒▒▒▒▒      ▒▒▒▒▒▒
█████    ██████    █████  █████████████████  ███▓▓▓     ▓▓▓▓▓  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓  ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
█████    ██████    █████   ████████████████  ██▓▓▓▓     ▓▓▓▓▓   ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓   ▒▒▒▒▒▒▒▒▒▒▒▒▒▒
█████    ██████    █████     ██████████████  █▓▓▓▓▓     ▓▓▓▓▓       ▓▓▓▓▓  ▓▓▓▓▒      ▒▒▒▒▒▒▒▒
                                                                ▓▓▓▓▓▓▓ ▓▓▓▓▓▓▒▒
                                                                ▓▓▓▓▓▓▓▓▓▓▓▓▓▒▒
                                                                  ▓▓▓▓▓▓▓▓▓▓                              `

const contraEE = () => {
  if (isElectron) {
    console.log(contraLogoArt, contraLogoStyle)
    console.log(
      '%cNice, you found an easter egg! Contra is a Konami classic! All this silliness is brought to you by...',
      'color: #999999; font-family: monospace;',
    )
    console.log(mangoLogoArt, mangoLogoStyle)
  }
}

export const easterEggSequences = {
  keys: [
    { code: 'ArrowUp' },
    { code: 'ArrowUp' },
    { code: 'ArrowDown' },
    { code: 'ArrowDown' },
    { code: 'ArrowLeft' },
    { code: 'ArrowRight' },
    { code: 'ArrowLeft' },
    { code: 'ArrowRight' },
    { code: 'KeyB' },
    { code: 'KeyA' },
    { code: 'Enter' },
  ],
  callback: contraEE,
}
